import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App.jsx";
import "./instrument.js"
import * as Sentry from "@sentry/react";

export const API_URL = "https://api.coudy.ai";
export const SOCKETS_URL = "https://sockets.coudy.ai";

const root = ReactDOM.createRoot(document.getElementById('root'), {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
